import { lazy } from 'react';

export const CountryList = lazy(() => import('./country/CountryList'));
export const StateList = lazy(() => import('./state/StateList'));
export const CityList = lazy(() => import('./city/CityList'));
export const ChargesTypeList = lazy(() => import('./chargesType/ChargesTypeList'));
export const Charges = lazy(() => import('./charges/Charges'));
export const ChecklistList = lazy(() => import('./checklist/ChecklistList'));
export const ServiceTypeList = lazy(() => import('./serviceType/ServiceTypeList'));
export const ServiceSubTypeList = lazy(() => import('./serviceSubType/ServiceSubTypeList'));
export const DeliveryPartnerList = lazy(() => import('./deliveryPartner/DeliveryPartnerList'));
export const ExpenseTypeList = lazy(() => import('./expenseType/ExpenseTypeList'));
export const NoticeTypeList = lazy(() => import('./noticeType/NoticeTypeList'));